<div class="relative flex h-full flex-col justify-center overflow-hidden border-r border-line bg-surface-2 p-14">
  <div class="nsa-map absolute inset-0" aria-hidden="true"></div>

  <div class="relative flex max-w-[420px] flex-col gap-5">
    @if(!!eyebrow()) {
      <p class="m-0 text-xs font-bold tracking-[0.26em] text-ink-3">{{ eyebrow() }}</p>
    }
    @if(!!title()) {
      <p class="text-[40px] font-extrabold leading-[1.15] text-ink">{{ title() }}</p>
    }
    @if(!!subtitle()) {
      <p class="text-[15px] leading-[1.6] text-ink-3">{{ subtitle() }}</p>
    }
  </div>
</div>